module.exports = __webpack_public_path__ + "static/media/lima-cap-LLC-Logo-small.6dd8da9d.png";